import { render, staticRenderFns } from "./AiEditorVideo.vue?vue&type=template&id=37a4da4e&"
import script from "./AiEditorVideo.vue?vue&type=script&lang=js&"
export * from "./AiEditorVideo.vue?vue&type=script&lang=js&"
import style0 from "./AiEditorVideo.vue?vue&type=style&index=0&id=37a4da4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports